import { LazyLoadImage } from 'react-lazy-load-image-component';
import Skeleton from 'react-loading-skeleton';

import { Typography } from '#atoms/index';
import { useWindowSize } from '#hooks/index';

const GameJamBullying = () => {
  const { isMobile } = useWindowSize();

  return (
    <section className="game-jam-bullying-Wrapper">
      <div className="game-jam-bullying">
        {/* Text */}
        <div className="game-jam-bullying__text">
          <Typography
            variant="regular regular-4 bold"
            tag="h2"
            style={{
              color: '#FD43DE',
              lineHeight: isMobile ? '32px' : '42px',
              textTransform: 'uppercase'
            }}
          >
            Taller y Concurso de creación de videojuegos
          </Typography>

          <Typography
            variant="regular regular-6 mb-2 mt-2 bold"
            tag="p"
            style={{ color: '#DBD1FD', lineHeight: isMobile ? '24px' : '30px' }}
          >
            8 sesiones de 1h15m
          </Typography>

          <Typography
            variant="regular regular-6"
            tag="p"
            style={{ color: '#DBD1FD', lineHeight: isMobile ? '24px' : '30px' }}
          >
            Tu hij@ aprenderá a programar su propio videojuego usando la herramienta
            GameMaker y participará con su creación en la competencia por increíbles
            premios.
          </Typography>
        </div>

        {/* Background Img */}
        <div className="game-jam-bullying__background-img">
          <LazyLoadImage
            width={isMobile ? '350px' : 'auto'}
            effect="blur"
            alt={'background1-bullying'}
            src={'./game-jam/bullying/mouster1-bullying.png'}
            placeholder={<Skeleton width="100%" height="100%" />}
          />
        </div>
      </div>
    </section>
  );
};

export default GameJamBullying;
